import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    letter-spacing: -0.02em;
`;

export const TitleLarge = styled.div`
    ${typographyBase};
    font-size: 32px;
    font-weight: 700;
`;

export const TitleMedium = styled.h3`
    ${typographyBase};
    font-size: 24px;
    font-weight: 700;
`;

export const Summary = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-bottom: 20px;
    width: 100%;
    align-items: start;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    text-align: left;
`;

export const SummaryHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const SummaryCount = styled.span`
    ${typographyBase};
    font-size: 18px;
    font-weight: 700;
`;

export const Actions = styled.div`
    margin-top: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
`;

export const ActionLink = styled.a`
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    letter-spacing: -0.2px;
`;

export const ActionTile = styled.button`
    width: 100%;
    border: none;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.05);
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 10px;

    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    font-weight: 500;
`;

export const ActionTitle = styled.h4`
    ${typographyBase};
    font-size: 22px;
    font-weight: 700;
`;
